import { EPromoInventoryActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeActiveBannerIndex = actionGenerator<
  EPromoInventoryActionType.ActiveBannerIndexChanged,
  number | null
>(EPromoInventoryActionType.ActiveBannerIndexChanged);
